import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notifications: [],
  count: 0,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotifications: (state, action) => {
        state.notifications = action.payload.filter(
            (n, index, self) => index === self.findIndex((t) => t.id === n.id)
        );
        state.count = state.notifications.length;
    },
    setNotificationCount: (state, action) => {
      state.count = action.payload;
    },
    addNotification: (state, action) => {
        const exists = state.notifications.some(
            (n) => n.id === action.payload.id
        );
        if (!exists) {
            state.notifications.unshift(action.payload);
            state.count += 1;
        }
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (n) => n.id !== action.payload
      );
      state.count = state.notifications.length;
    },
    clearNotifications: (state) => {
      state.notifications = [];
      state.count = 0;
    },
  },
});

export const {
  setNotifications,
  setNotificationCount,
  addNotification,
  removeNotification,
  clearNotifications,
} = notificationSlice.actions;
export default notificationSlice.reducer;
